import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { INVALIDATE_TYPE } from "../actionTypes.js";
export default function createInvalidate(endpoint, _ref) {
  var args = _ref.args;
  return {
    type: INVALIDATE_TYPE,
    meta: {
      key: endpoint.key.apply(endpoint, _toConsumableArray(args))
    }
  };
}